import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import eventIcon from '../assets/new-icon-robinhood.jpg';
import eventFlyer from '../assets/Locandina_RobinHood_evento_18_ottobre 2025-1.png';

// Foto evento 18 ottobre 2025
import foto18Ott1 from '../assets/evento-18-ottobre/PA181517.JPG';
import foto18Ott2 from '../assets/evento-18-ottobre/PA181522.JPG';
import foto18Ott3 from '../assets/evento-18-ottobre/PA181525.JPG';
import foto18Ott4 from '../assets/evento-18-ottobre/PA181529.JPG';
import foto18Ott5 from '../assets/evento-18-ottobre/PA181540.JPG';
import foto18Ott6 from '../assets/evento-18-ottobre/PA181568.JPG';
import foto18Ott7 from '../assets/evento-18-ottobre/PA181581.JPG';
import foto18Ott8 from '../assets/evento-18-ottobre/PA181611.JPG';
import foto18Ott9 from '../assets/evento-18-ottobre/PA181613.JPG';
import foto18Ott10 from '../assets/evento-18-ottobre/PA181618.JPG';
import foto18Ott11 from '../assets/evento-18-ottobre/PA181621.JPG';
import foto18Ott12 from '../assets/evento-18-ottobre/PA181642.JPG';
import foto18Ott13 from '../assets/evento-18-ottobre/PA181653.JPG';
import foto18Ott14 from '../assets/evento-18-ottobre/PA181670.JPG';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

const Evento18Ottobre = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isYogaModalOpen, setIsYogaModalOpen] = useState(false);
  const [isCarTModalOpen, setIsCarTModalOpen] = useState(false);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [isWaitingRoomModalOpen, setIsWaitingRoomModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  
  const eventPhotos = [
    foto18Ott1, foto18Ott2, foto18Ott3, foto18Ott4, foto18Ott5, foto18Ott6, foto18Ott7,
    foto18Ott8, foto18Ott9, foto18Ott10, foto18Ott11, foto18Ott12, foto18Ott13, foto18Ott14
  ];
  
  return (
    <div className="container mx-auto px-4 py-8">
      {/* Hero Section */}
      <div className="bg-green-50 rounded-lg p-6 mb-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex-1">
            <h1 className="text-4xl font-bold text-green-800 mb-4">Il Futuro è Già nel Presente</h1>
            <p className="text-xl font-semibold text-green-700 mb-4">
              Una giornata per i pazienti: progetti e solidarietà
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/sostienici" 
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors uppercase text-center"
              >
                Sostieni il Progetto
              </Link>
              <button
                onClick={() => document.getElementById('photo-gallery').scrollIntoView({ behavior: 'smooth', block: 'start' })}
                className="inline-flex items-center justify-center px-6 py-3 bg-green-600 text-white font-bold rounded-md hover:bg-green-700 transition-colors uppercase"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Guarda le Foto dell'Evento
              </button>
            </div>
          </div>
          <img 
            src={eventIcon} 
            alt="Event Icon" 
            className="w-48 h-auto object-contain"
          />
        </div>
      </div>

      {/* Report Section */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-3xl font-bold text-green-800 mb-6 text-center">"Il futuro è già nel presente!"</h2>
        
        <div className="space-y-4 text-gray-700 leading-relaxed">
          <p>
            Una giornata intensa, partecipata e ricca di spunti quella che si è svolta sabato <strong>18 ottobre 2025</strong> presso l'<strong>Albergo Etico di Roma</strong>. L'<strong>Associazione Robin Hood Roma ODV</strong> ha riunito soci, pazienti, medici e sostenitori per un appuntamento dedicato <strong>alla presentazione di progetti, alla raccolta fondi</strong> e alla condivisione di nuove prospettive per il futuro.
          </p>
          
          <p>
            L'incontro, dal titolo significativo <em>"Il futuro è già nel presente!"</em>, ha unito momenti di approfondimento scientifico, esperienze umane e iniziative di benessere, confermando lo spirito che pervade l'associazione.
          </p>
          
          <h3 className="text-2xl font-bold text-green-800 mt-6 mb-3">Mattina tra cultura e benessere</h3>
          
          <p>
            La prima parte della giornata è stata dedicata alla presentazione del libro <em>"Educazione fisica nella scuola in ospedale"</em>, scritto da <strong>Mario Cistulli, Mario Bellucci</strong> e <strong>Rita Casella</strong>, con la moderazione della dott.ssa <strong>Anna Maria Testi</strong>.
          </p>
          
          <p>
            Il Prof. <strong>Mario Cistulli</strong> ha guidato un coinvolgente momento di <strong>yoga collettivo</strong> introducendo il primo dei progetti sostenuti dell'Associazione: <strong>il Programma Yoga destinato a pazienti ricoverati nei reparti della UOC di Ematologia</strong>, pensato per migliorare il benessere psicofisico dei pazienti durante la degenza ospedaliera.
          </p>
          
          <h3 className="text-2xl font-bold text-green-800 mt-6 mb-3">Pomeriggio di progetti e nuove sfide</h3>
          
          <p>
            Nel pomeriggio la <strong>Dr.ssa Fiorina Giona</strong> ha dato voce a professionisti e volontari impegnati nella presentazione degli altri nuovi progetti dell'associazione.
          </p>
          
          <p>
            Il Prof. <strong>Maurizio Martelli, direttore della UOC di Ematologia</strong>, presente all'evento, ha moderato la seduta pomeridiana ed espresso grande apprezzamento per i progetti presentati, sostenuti dall'Associazione.
          </p>
          
          <p>
            La <strong>Dott.ssa Silvia Trisolini</strong> ha illustrato il <strong>Progetto ADAMTS13</strong>, che si propone di assicurare una diagnosi tempestiva e un monitoraggio adeguato ai pazienti affetti da <strong>porpora trombotica trombocitopenica</strong>.
          </p>
          
          <p>
            A seguire, la <strong>Dott.ssa Alice Di Rocco</strong> ha parlato delle <strong>terapie innovative</strong> che stanno rivoluzionando la cura di molte patologie ematologiche, introducendo l'intervento delle <strong>Dott.sse Marta Montanari</strong> e <strong>Marta Pierfederici</strong>, che hanno presentato <strong>il progetto di supporto per le famiglie e i pazienti sottoposti a terapia con CAR-T o a trapianto di cellule staminali</strong> emopoietiche.
          </p>
          
          <p>
            La <strong>Dott.ssa Silvia Finocchi</strong> ha poi chiuso l'evento con la presentazione di iniziative atte a rendere più accogliente i momenti trascorsi nelle sale di attesa degli ambulatori, trasformandoli in occasioni di socialità e leggerezza.
          </p>
          
          <h3 className="text-2xl font-bold text-green-800 mt-6 mb-3">Un arrivederci pieno di energia</h3>
          
          <p>
            L'incontro si è concluso in un clima di entusiasmo e partecipazione, con la promessa di proseguire insieme il cammino di solidarietà e innovazione che contraddistingue l'associazione.
          </p>
          
          <p>
            L'Associazione Robin Hood Roma ODV ringrazia di cuore tutti i relatori, i volontari e i partecipanti che hanno reso possibile questa giornata di confronto e speranza.
          </p>
          
          <p>
            Un evento che, come recita il titolo, ha dimostrato che <strong>"il futuro è davvero già nel presente</strong>.
          </p>
          
          <div className="bg-yellow-50 p-4 rounded-md mt-6">
            <p className="text-gray-700">
              Un ringraziamento speciale è rivolto all'<strong>Albergo Etico di Roma</strong>, che ha ospitato l'evento con grande disponibilità, <strong>mettendo generosamente a disposizione i propri spazi e contribuendo in modo concreto</strong> alla riuscita della giornata. Un gesto che testimonia la sua vocazione all'inclusione e all'accoglienza e la piena condivisione dei valori di solidarietà e collaborazione che animano la nostra Associazione.
            </p>
          </div>
        </div>
      </div>

      {/* Event Poster */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h2 className="text-2xl font-bold text-green-800 mb-6 text-center">Locandina dell'Evento</h2>
        <div className="flex justify-center">
          <img 
            src={eventFlyer} 
            alt="Locandina Evento 18 Ottobre 2025" 
            className="max-w-full h-auto rounded-lg shadow-lg"
          />
        </div>
      </div>

      {/* Projects Section */}
      <div className="mb-8">
        <h2 className="text-3xl font-bold text-green-800 mb-8 text-center">Progetti</h2>
        
        {/* Progetto Yoga */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h3 className="text-2xl font-bold text-green-800 mb-3">PROGRAMMA YOGA PER I PAZIENTI RICOVERATI IN EMATOLOGIA</h3>
          <p className="text-lg italic text-gray-600 mb-6">
            "Lo yoga in reparto non è esercizio, ma un abbraccio silenzioso: un modo per ritrovare forza, sollievo ed equilibrio interiore anche nei giorni più complessi."
          </p>
          <div className="space-y-4">
            <p className="text-gray-700">
              Il Programma Yoga per i pazienti ricoverati in Ematologia nasce con l'intento di affiancare al percorso terapeutico un'esperienza di benessere, ascolto e armonia interiore. Attraverso pratiche dolci, sicure e adattate alle condizioni cliniche di ciascun paziente, lo Yoga diventa un alleato nel ridurre ansia e stress, migliorare il riposo, favorire la concentrazione e sostenere le risorse personali. L'obiettivo è trasformare il tempo della degenza in un'occasione di cura non solo del corpo, ma anche della mente e delle emozioni, offrendo ai pazienti un prezioso spazio di serenità e resilienza.
            </p>
            <div className="mt-6">
              <button 
                onClick={() => setIsYogaModalOpen(true)}
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors"
              >
                Vai al progetto
              </button>
            </div>
          </div>
        </div>

        {/* Progetto ADAMTS13 */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h3 className="text-2xl font-bold text-green-800 mb-3">PROGETTO ADAMTS13: UN AIUTO CONCRETO AI PAZIENTI CON LA PTT (PORPORA TROMBOTICA TROMBOCITOPENICA)</h3>
          <p className="text-lg italic text-gray-600 mb-6">
            "Ogni contributo diventa cura: sostieni il progetto"
          </p>
          <div className="space-y-4">
            <p className="text-gray-700">
              Il progetto ADAMTS13 si propone di assicurare una diagnosi tempestiva e un monitoraggio adeguato ai pazienti affetti da porpora trombotica trombocitopenica (PTT), una rara malattia ematologica causata da un deficit dell'enzima ADAMTS13, che porta alla formazione di trombi nei piccoli vasi sanguigni, con danni a diversi organi e tessuti. È un impegno concreto e costoso (oltre 50.000 euro l'anno) per rispondere al bisogno di assistenza e alla necessità di risposte tempestive ed efficaci dei pazienti con PTT.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3 md:gap-4">
              <button 
                onClick={() => setIsModalOpen(true)}
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors text-center"
              >
                Conosci la malattia e il progetto
              </button>
              <Link 
                to="/sostienici" 
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors text-center"
              >
                Dai il tuo contributo
              </Link>
            </div>
          </div>
        </div>

        {/* Progetto Terapie Innovative CAR-T */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h3 className="text-2xl font-bold text-green-800 mb-3">TERAPIE INNOVATIVE. PROGETTO DI SUPPORTO PER LE FAMIGLIE E I PAZIENTI SOTTOPOSTI A TERAPIA CON CAR-T E A TRAPIANTO DI CELLULE STAMINALI</h3>
          <p className="text-lg italic text-gray-600 mb-6">
            "Un sostegno che accompagna e rassicura lungo la strada delle terapie più innovative"
          </p>
          <div className="space-y-4">
            <p className="text-gray-700">
              Il progetto mira a fornire un supporto ai pazienti e alle loro famiglie, offrendo informazioni chiare e pratiche sulle terapie e sulle eventuali complicanze che possono comparire dopo la dimissione dal reparto di degenza dei pazienti sottoposti a terapie innovative o a trapianto di cellule staminali per una gestione condivisa e consapevole. L'obiettivo è migliorare la qualità della vita dei pazienti e dei loro familiari, ridurre l'ansia e lo stress associati alla dimissione e alla malattia.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3 md:gap-4">
              <button 
                onClick={() => setIsCarTModalOpen(true)}
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors text-center"
              >
                Scopri le TERAPIE CELLULARI con CAR-T
              </button>
              <button 
                onClick={() => setIsSupportModalOpen(true)}
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors text-center"
              >
                Vai al progetto
              </button>
            </div>
          </div>
        </div>

        {/* Progetto Sala d'Attesa */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h3 className="text-2xl font-bold text-green-800 mb-3">PROGETTARE UN'ATTESA PIÙ RILASSANTE</h3>
          <p className="text-lg italic text-gray-600 mb-6">
            "Un luogo di attesa pensato per offrire comfort, calma e vicinanza"
          </p>
          <div className="space-y-4">
            <p className="text-gray-700">
              Il progetto della sala d'attesa nasce dal desiderio di offrire ai pazienti con malattie ematologiche rare e ai loro familiari uno spazio accogliente e confortevole che sappia trasmettere serenità e dignità, trasformando il tempo dell'attesa in un momento di cura e attenzione verso la persona.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3 md:gap-4">
              <button 
                onClick={() => setIsWaitingRoomModalOpen(true)}
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors text-center"
              >
                Vai al progetto
              </button>
              {/* <Link 
                to="#" 
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors text-center"
              >
                Suggerimenti
              </Link> */}
            </div>
          </div>
        </div>

        {/* Progetto ADAMTS13 - Commentato */}
        {/* <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <h3 className="text-2xl font-bold text-green-800 mb-6">Progetto ADAMTS13: Un'Iniziativa Cruciale</h3>
          <div className="space-y-4">
            <p className="text-gray-700">
              La porpora trombotica trombocitopenica (PTT) è una rara malattia che colpisce prevalentemente 
              giovani e bambini ed è gravata da una elevata mortalità se non prontamente trattata. Nella maggior parte 
              dei casi è una patologia autoimmune, caratterizzata da una deficiente attività della metalloproteasi ADAMTS13, 
              che determina una iper aggregazione piastrinica con conseguente formazione di trombi nella microcircolazione 
              e danni ischemici tissutali a livello di tutti gli organi, soprattutto cuore, cervello e intestino.
            </p>
            <button 
              onClick={() => setIsModalOpen(true)}
              className="text-green-700 hover:text-green-800 font-medium underline"
            >
              Scopri di più sulla PTT e il progetto
            </button>
            
            <div className="mt-6">
              <Link 
                to="/sostienici" 
                className="inline-block px-6 py-3 bg-red-600 text-white font-bold rounded-md hover:bg-red-700 transition-colors"
              >
                SOSTIENI IL PROGETTO
              </Link>
            </div>
          </div>
        </div> */}
      </div>

      {/* Event Flyer */}
      {/* <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-green-800 mb-6">Locandina dell'Evento</h2>
        <img 
          src={eventFlyer} 
          alt="Locandina Evento 18 Ottobre" 
          className="max-w-full rounded-lg shadow-lg mx-auto"
        />
      </div> */}

      {/* Photo Gallery */}
      <div id="photo-gallery" className="bg-white rounded-lg shadow-md p-6 mb-8 scroll-mt-8">
        <h2 className="text-2xl font-bold text-green-800 mb-6">Le Foto dell'Evento del 18 Ottobre 2025</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {eventPhotos.map((photo, index) => (
            <div 
              key={index}
              className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer group"
              onClick={() => setSelectedImage(photo)}
            >
              <img 
                src={photo} 
                alt={`Evento 18 Ottobre - Foto ${index + 1}`} 
                className="w-full h-48 object-cover transform group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-opacity duration-300 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v6m3-3H7" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-6xl max-h-full">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={selectedImage} 
              alt="Foto evento ingrandita" 
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}

      {/* Modal Waiting Room Project */}
      <Modal isOpen={isWaitingRoomModalOpen} onClose={() => setIsWaitingRoomModalOpen(false)}>
        <div className="space-y-6">
          <div className="text-center">
            <img 
              src={eventIcon} 
              alt="Robin Hood Logo" 
              className="w-32 h-auto object-contain mx-auto mb-6"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-primary mb-2">
              PROGETTARE UN'ATTESA PIÙ RILASSANTE
            </h1>
            <p className="text-lg text-gray-700 italic mb-6">Dott.ssa Silvia Finocchi</p>
          </div>

          <section>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le sale d'attesa degli ambulatori di Ematologia rappresentano uno spazio cruciale non solo dal punto di vista logistico, ma anche dal punto di vista psicologico ed emotivo dei pazienti e dei loro familiari dal momento che accolgono persone spesso fragili, immunodepresse e soggette a forti stati di ansia. Sono state create per assicurare al paziente condizioni sicure, confortevoli e funzionali per l'attesa delle visite, delle terapie o dei controlli. Con il tempo possono emergere criticità diverse legate alla gestione degli spazi, al comfort fisico, alla privacy, alla comunicazione e al supporto emotivo. Il sovraffollamento, la scarsa accessibilità, il rumore, la lunga attesa e la mancanza di informazioni chiare possono amplificare lo stress dei pazienti e ridurre la percezione di qualità dell'assistenza.
              </p>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg">
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Inoltre, manca uno spazio dove isolarsi o svolgere attività ricreative, leggere. A volte, si ha la sensazione, nella sala d'attesa, che il tempo sia sospeso. Vi siete mai chiesti cosa accadrebbe se, in questo spazio, lasciassimo posto al silenzio e all'ascolto profondo di noi stessi? Accadrebbe che i pensieri lentamente prenderebbero una forma più chiara e le emozioni potrebbero trovare la loro voce. Rallentando ci si può ascoltare e lasciare che desideri e paure emergano. In una sala d'attesa, che alle volte ci può lasciare sospesi, la consapevolezza può mostrarci nuovi significati.
              </p>
              <p>
                Analizzare le criticità e identificare i bisogni dei pazienti e dei loro familiari possono permettere di individuare interventi mirati per migliorarne l'esperienza, ottimizzare i flussi organizzativi, garantire un ambiente più sicuro, accogliente e rispettoso delle esigenze specifiche di chi affronta queste patologie, cercando di trasformare l'attesa in un momento di cura e di attenzione verso la persona.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-primary mb-4">Il questionario</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                A tale scopo abbiamo pensato di formulare un questionario molto semplice con domande specifiche, volte a comprendere i bisogni, le percezioni e le aspettative dei pazienti con malattie ematologiche e degli accompagnatori durante la permanenza nelle sale d'attesa degli ambulatori.
              </p>
              <p>
                I questionari verranno distribuiti dai volontari nelle diverse sale d'attesa dell'ambulatorio negli ultimi mesi del 2025. Si è liberi di rispondere a tutte le domande o solo ad alcune di esse.
              </p>
              <p className="font-semibold">
                È garantito l'anonimato.
              </p>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg border-l-4 border-primary">
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le risposte ci aiuteranno a raccogliere informazioni dirette dai pazienti e dagli accompagnatori per identificare criticità e opportunità di miglioramento nelle sale d'attesa degli ambulatori di Ematologia, e a progettare interventi che migliorino il benessere, riducano lo stress e rendano l'esperienza più umana e accogliente.
              </p>
            </div>
          </section>
        </div>
      </Modal>

      {/* Modal Support Project */}
      <Modal isOpen={isSupportModalOpen} onClose={() => setIsSupportModalOpen(false)}>
        <div className="space-y-6">
          <div className="text-center">
            <img 
              src={eventIcon} 
              alt="Robin Hood Logo" 
              className="w-32 h-auto object-contain mx-auto mb-6"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-primary mb-2">
              PROGETTO DI SUPPORTO PER LE FAMIGLIE E I PAZIENTI SOTTOPOSTI A TERAPIA CON CAR-T E A TRAPIANTO DI CELLULE STAMINALI
            </h1>
            <p className="text-lg text-gray-700 italic mb-6">Marta Montanari, coordinatrice infermieristica, e Marta Pierfederici, infermiera.</p>
          </div>

          <section>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Siamo due operatrici che lavorano presso il reparto di Terapie Innovative della U.O.C. dell'Ematologia del Policlinico Umberto I, impegnate nella cura e nel supporto dei pazienti sottoposti a trattamenti avanzati. Attualmente stiamo frequentando il Master di I livello "CAR-T Therapy e Trapianto di CSE: gestione delle prevenzioni e complicanze", con il supporto finanziario dell'Associazione Robin Hood Roma ODV.
              </p>
              <p>
                Per l'elaborato finale del Master, Il nostro progetto prevede la realizzazione di un vademecum informativo, destinato a tutti i pazienti ricoverati nel nostro reparto: trapiantati, candidati alla terapia CAR-T, protocolli di chemioterapia, anticorpi monoclonali o bispecifici. <span className="text-red-600 font-semibold">La brochure raccoglierà in un unico strumento tutte le informazioni necessarie: spiegazioni semplici e chiare sulle terapie, il percorso di ricovero, le principali precauzioni e le risposte alle domande più frequenti.</span>
              </p>
              <p>
                La motivazione e l'importanza della brochure risiedono nella necessità di fornire ai pazienti uno strumento chiaro e accessibile, che riduca ansia e incertezza, favorisca la comprensione del percorso terapeutico e supporti l'aderenza alle indicazioni cliniche. Sarà utile sia al momento della presa in carico sia alla dimissione, permettendo di avere sempre a portata di mano informazioni affidabili e comprensibili.
              </p>
              <p>
                Il sostegno dell'Associazione Robin Hood ci permetterà di produrre e stampare brochure informative che offriranno ai pazienti indicazioni chiare e utili, contribuendo così a migliorare in modo tangibile la loro esperienza, la sicurezza e il benessere nel reparto.
              </p>
            </div>
          </section>
        </div>
      </Modal>

      {/* Modal CAR-T Therapies */}
      <Modal isOpen={isCarTModalOpen} onClose={() => setIsCarTModalOpen(false)}>
        <div className="space-y-6">
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-primary mb-2">
              TERAPIE CELLULARI CON CAR-T
            </h1>
            <p className="text-lg text-gray-700 italic mb-6">Dott.ssa Alice Di Rocco</p>
          </div>

          <section>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Le terapie cellulari basate sull'infusione delle cellule CAR-T (acronimo dall'inglese <em>Chimeric Antigen Receptor – T cells</em>) sono considerate tra le frontiere più innovative della medicina.
              </p>
              <p>
                Il meccanismo di azione di queste terapie si basa su un concetto semplice ma innovativo: <span className="text-red-600 font-semibold">agire direttamente sul sistema immunitario per combattere i tumori</span> come se fossero un agente estraneo al corpo, "risvegliando" <span className="text-red-600 font-semibold">la risposta immunitaria e attivandola per riconoscere le cellule maligne e ucciderle</span>.
              </p>
              <p>
                A causa della loro <span className="text-red-600 font-semibold">complessità</span>, la gestione di queste terapie viene seguita da un <span className="text-red-600 font-semibold">team multidisciplinare composto da ematologi, medici trasfusionisti, rianimatori, infettivologi, neurologi, radiologi, biologi e farmacisti, e personale infermieristico qualificato</span> che in squadra possono prevenire, affrontare e risolvere gli eventi avversi collegati alla reinfusione di cellule CAR-T.
              </p>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg">
            <h3 className="text-2xl font-bold text-primary mb-4">Il processo di preparazione</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                La terapia con CAR-T richiede una complessa preparazione che ha inizio con un prelievo di sangue venoso periferico del paziente per isolare i linfociti T dal resto del materiale ematico. Attraverso una tecnica chiamata <span className="text-red-600 font-semibold">aferesi</span> si raccolgono i linfociti T responsabili della sorveglianza immunitaria e della produzione di sostanze chiamate citochine che svolgono un ruolo importante nelle risposte cellulari immunologiche, nel controllo dei processi infiammatori, di crescita e di differenziazione cellulare.
              </p>
              <p>
                I linfociti T raccolti vengono poi inviati presso i laboratori di produzione e manipolazione cellulare (<em>cell factory</em>) per essere sottoposti al processo di ingegnerizzazione, secondo un rigido protocollo di controllo di qualità. Una volta in laboratorio, all'interno dei linfociti viene introdotto il recettore CAR (<em>Chimeric Antigen Receptor</em>) capace di riconoscere le cellule tumorali. La procedura ha una durata di <span className="text-red-600 font-semibold">circa 3-4 settimane</span>, trascorse le quali le cellule CAR-T prodotte devono passare i controlli di qualità e vengono criopreservate diventando un farmaco che ritorna al centro di cura per essere reinfuso al paziente.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-primary mb-4">Il processo di infusione</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Il paziente viene ricoverato <span className="text-red-600 font-semibold">circa una settimana prima dell'infusione</span> per completare alcuni accertamenti non eseguiti in regime ambulatoriale e per essere sottoposto a una <span className="text-red-600 font-semibold">chemioterapia linfodepletiva</span>, che ha lo scopo di distruggere i linfociti del paziente e permettere alle cellule CAR-T di espandersi e moltiplicarsi nel corpo, attaccando le cellule tumorali. La chemioterapia linfodepletiva dura 3 giorni a cui seguono circa 2-3 giorni di "riposo" prima dell'infusione delle cellule CAR-T.
              </p>
              <p>
                Il prodotto CAR-T, previo scongelamento, può essere infuso nel paziente con un procedimento simile a una trasfusione di sangue, tramite catetere venoso centrale. Per far fronte ai possibili effetti collaterali, dopo la reinfusione il paziente viene trasportato in terapia intensiva, dove resta <span className="text-red-600 font-semibold">circa 7 giorni</span> durante i quali viene costantemente monitorato prima di tornare nel reparto di Ematologia.
              </p>
            </div>
          </section>

          <section className="bg-red-50 p-6 rounded-lg">
            <h3 className="text-2xl font-bold text-red-600 mb-4">Effetti collaterali</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                L'immunoterapia con cellule CAR-T si è dimostrata in grado di indurre risposte cliniche rapide e durature, ma può essere associata allo sviluppo di eventi acuti, anche molto severi e generalmente reversibili, e di effetti collaterali a lungo temine.
              </p>
              
              <div className="space-y-4">
                <div>
                  <h4 className="font-bold text-red-600 mb-2">• La sindrome da rilascio di citochine</h4>
                  <p>
                    È la tossicità più comune (<span className="text-red-600 font-semibold">oltre il 70% dei pazienti</span>) ed è caratterizzata da una reazione infiammatoria sistemica determinata da un aumento consistente di citochine nell'organismo. I sintoni, quale <span className="text-red-600 font-semibold">febbre, ipotensione, tachicardia, ipossia, disfunzione d'organo</span> possono essere di entità variabile, da lievi a potenzialmente fatali. Un trattamento immediato e adeguato ne favorisce la risoluzione.
                  </p>
                </div>

                <div>
                  <h4 className="font-bold text-red-600 mb-2">• La tossicità neurologica</h4>
                  <p>
                    Il secondo evento avverso più frequente è la neurotossicità. I sintomi neurologici possono insorgere entro i primi <span className="text-red-600 font-semibold">7–10 giorni</span> dopo l'infusione, e sono rappresentati da <span className="text-red-600 font-semibold">tremore, disturbi della scrittura e dell'eloquio, sonnolenza, stato di confusione, disorientamento, convulsioni</span>. In genere, con il trattamento regrediscono completamente; in alcuni casi, possono lasciare degli esiti.
                  </p>
                </div>

                <div>
                  <h4 className="font-bold text-red-600 mb-2">• Le citopenie</h4>
                  <p>
                    Ovvero la riduzione dei globuli rossi, dei neutrofili e delle piastrine, possono essere prolungate, fino a settimane o mesi. Come conseguenza c'è un <span className="text-red-600 font-semibold">rischio aumentato di infezioni, di sanguinamenti, di necessità di trasfusioni di sangue</span> per l'anemia.
                  </p>
                </div>

                <div>
                  <h4 className="font-bold text-red-600 mb-2">• Le infezioni</h4>
                  <p>
                    Anche da germi normalmente non patogeni, sono frequenti nelle settimane successive all'infusione e possono insorgere <span className="text-red-600 font-semibold">oltre tre mesi dall'infusione</span>, malgrado una terapia preventiva.
                  </p>
                </div>

                <div>
                  <h4 className="font-bold text-red-600 mb-2">• L'ipogammaglobulinemia</h4>
                  <p>
                    Ovvero la riduzione delle immunoglobuline, è una conseguenza a lungo termine di una forte riduzione dei linfociti B normali (target del CAR-T), che normalmente producono le immunoglobuline. Questa condizione aumenta il rischio di infezioni.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg border-l-4 border-primary">
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Dopo la dimissione sono previsti, <span className="text-red-600 font-semibold">controlli ambulatoriali frequenti</span>, per un tempo variabile da paziente a paziente, fino a completa normalizzazione dei valori dell'emocromo e degli altri esami ematici. Successivamente, i controlli per il monitoraggio degli effetti collaterali e della malattia di base, vengono proseguiti secondo indicazioni specifiche.
              </p>
              <p className="font-semibold">
                Considerando l'entità degli effetti a lungo termine della terapia con CART è importante <span className="text-red-600">una sensibilizzazione del paziente e dei familiari nel riconoscere i sintomi</span>, dopo la dimissione dal reparto di Ematologia.
              </p>
            </div>
          </section>
        </div>
      </Modal>

      {/* Modal Yoga Program */}
      <Modal isOpen={isYogaModalOpen} onClose={() => setIsYogaModalOpen(false)}>
        <div className="space-y-6">
          <div className="text-center">
            <img 
              src={eventIcon} 
              alt="Robin Hood Logo" 
              className="w-32 h-auto object-contain mx-auto mb-6"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-primary mb-2">
              PROGRAMMA YOGA PER I PAZIENTI RICOVERATI IN EMATOLOGIA
            </h1>
            <p className="text-lg text-gray-700 italic mb-6">Prof. Mario Cistulli</p>
          </div>

          <section>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Questo programma è proposto e coordinato dal Prof Mario Cistulli e supportato dall’Associazione Robin Hood Roma ODV.
              </p>
              <p>
                E’ destinato ai pazienti ricoverati nel reparto <span className="text-red-600 font-semibold">“Adulti”</span> e nel reparto <span className="text-red-600 font-semibold">“Autotrapianti”</span> della <span className="text-red-600 font-semibold">UOC Ematologia dell’AOU Policlinico Umberto I di Roma</span>. Riprende una precedente iniziativa sostenuta dalla RomaAIL, interrotta a causa della pandemia Covid.
              </p>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  Un gruppo di <span className="text-red-600 font-semibold">6 insegnanti di yoga nella tradizione di T.K.V. Desikachar</span>, coordinati e supervisionati da Mario Cistulli, offrirà, come servizio di volontariato, <span className="text-red-600 font-semibold">incontri individuali</span> - nelle stanze di degenza – ai pazienti ricoverati per emopatie maligne, soprattutto leucemie e linfomi, e malattie ematologiche rare.
                </li>
                <li>
                  Il progetto prevede un lavoro diretto con i pazienti e un lavoro indiretto articolato in riunioni di coordinamento e supervisione mensile in cui verranno revisionate le pratiche proposte e i principi applicati, si condivideranno i vissuti, le esperienze, le complessità affrontate.
                </li>
              </ul>
              <p>
                Inoltre, si terranno ulteriori riunioni di confronto e coordinamento tra i colleghi, e anche di verifica e monitoraggio del progetto con l’equipe sanitaria.
              </p>
              <p>
                Particolare importanza avrà la comunicazione e il coordinamento con i sanitari, per avere elementi importanti su cui fondare l’insegnamento dello yoga ai pazienti.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-primary mb-4 italic">Perché lo yoga in reparti di Ematologia?</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                I pazienti ricoverati nei reparti di Ematologia vivono spesso il rapporto con il corpo permeato di dolore, causato sia dalla patologia, sia dagli effetti collaterali di alcuni farmaci, e amplificato dalla comprensibile reazione emotiva alla situazione. Il corpo è visto spesso cambiare radicalmente in poco tempo.
              </p>
              <p>
                Imparare a porsi pacificamente in contatto con il corpo, ad accogliere - per quanto possibile - questa situazione così drammaticamente diversa, per affrontare con più serenità ed energia la situazione di malattia sono i principali obiettivi del progetto.
              </p>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg">
            <h3 className="text-2xl font-bold text-primary mb-4 italic">Obiettivi del programma</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Il progetto è finalizzato a favorire la riduzione delle tensioni e dello stress correlati alla malattia e alla degenza, attraverso semplici e delicati movimenti del corpo coordinati con il ritmo del respiro, esercizi di respirazione, esercizi di rilassamento e di meditazione.
              </p>
              <p>
                I movimenti sono coordinati con la respirazione ed eseguiti con il minimo sforzo e con il rilassamento delle tensioni inutili. Attraverso la pratica dello yoga, è possibile migliorare la coscienza del corpo, sentirlo sempre più profondamente, nonché sostenere una funzionalità raffinata. È inoltre possibile che le tensioni diminuiscano, e che si entri in contatto con uno stato di maggiore calma e fiducia.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-primary mb-4 italic">Quali pratiche verranno utilizzate?</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>Verranno proposte prevalentemente le seguenti pratiche:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>
                  <em>Āsana</em>. Movimenti di intensità fisica prevalentemente bassa, con la ricerca dell’attenzione costante su un’esperienza in cui si percepisce una sensazione di benessere.
                </li>
                <li>
                  Consapevolezza del respiro addominale.
                </li>
                <li>
                  <em>Prānāyāma</em>. Esercizi di allungamento del respiro, eseguiti con la ricerca di un respiro lungo, dolce, non forzato; si favorirà particolarmente l’allungamento dell’espirazione.
                </li>
                <li>
                  Rilassamento segmentario e globale.
                </li>
                <li>
                  Consapevolezza delle sensazioni del corpo e altri esercizi di meditazione.
                </li>
              </ul>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg">
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                Verrà adottata una metodologia che parte dall&#39;esperienza pratica e diretta dei pazienti. Tutte le proposte verranno adattate alla realtà, alle necessità dei singoli individui, seguendo le caratteristiche fondamentali della tradizione “Viniyoga”.
              </p>
              <p className="italic">
                Viniyoga significa adattare lo yoga alla persona che lo pratica, alle sue caratteristiche psicofisiche, alla sua età, alla sua cultura, alle sue necessità, ai suoi interessi, al suo ambiente sociale.
              </p>
            </div>
          </section>

          <section className="bg-red-50 p-6 rounded-lg border-l-4 border-red-600">
            <p className="text-gray-700 leading-relaxed">
              <span className="text-red-600 font-bold">Un elemento peculiare del progetto è che i pazienti, già dopo il primo incontro,
              potranno – se vorranno - praticare anche autonomamente gli esercizi proposti. A
              tale scopo verrà lasciata al paziente una sequenza scritta, costruita secondo ben
              ponderati e coerenti criteri.</span>
            </p>
          </section>
        </div>
      </Modal>

      {/* Modal ADAMTS13 */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="space-y-6">
          <div className="text-center">
            <img 
              src={eventIcon} 
              alt="Robin Hood Logo" 
              className="w-32 h-auto object-contain mx-auto mb-6"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-primary mb-2">
              PROGETTO ADAMTS13: UN AIUTO CONCRETO AI PAZIENTI CON LA PTT
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-4">
              (PORPORA TROMBOTICA TROMBOCITOPENICA)
            </h2>
            <p className="text-lg text-gray-700 italic mb-6">Dott.ssa Silvia Trisolini</p>
          </div>

          <section>
            <h3 className="text-2xl font-bold text-red-600 mb-4">Conosci la malattia</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                La porpora trombotica trombocitopenica (PTT), meglio conosciuta come Sindrome di Moschowitz, è una rara malattia che colpisce prevalentemente giovani e bambini ed è gravata da una elevata mortalità se non prontamente trattata. Nella maggior parte dei casi è una patologia autoimmune per cui vengono prodotti degli autoanticorpi contro l'enzima ADAMTS13.
              </p>
              <p>
                Alla base della patologia, vi è <span className="text-red-600 font-semibold">una deficiente attività dell'enzima ADAMTS13</span> una metalloproteasi che ha lo scopo di tagliare i multimeri ultra-large del fattore di von Willebrand, esposti in seguito ad un danno endoteliale dovuto a cause infettive, farmaci, traumi, interventi chirurgici. Ciò <span className="text-red-600 font-semibold">determina una iper-aggregazione piastrinica</span> con conseguente formazione di trombi nella microcircolazione e <span className="text-red-600 font-semibold">danni ischemici tissutali</span> a livello di tutti gli organi soprattutto <span className="text-red-600 font-semibold">cuore, cervello e intestino</span>. Per questo la malattia è gravata da un elevato rischio di mortalità e morbidità.
              </p>
              <p>
                Vi è una <span className="text-red-600 font-semibold">forma autoimmune (iTTP) acquisita</span> in cui vi è la produzione di autoanticorpi che inibiscono l'attività dell'ADAMTS13 la iTTP è la forma più frequente e comune soprattutto nei giovani adulti. Vi è una forma più rara quella <span className="text-red-600 font-semibold">congenita (cTTP)</span> più frequente nei bambini, alla base della quale vi è una o più mutazioni genetiche ereditarie che coinvolgono il gene che codifica per l'ADAMTS13, per cui la metalloproteasi non è prodotta oppure è deficiente.
              </p>
              <p>
                La <span className="text-red-600 font-semibold">diagnosi</span> della malattia viene sospettata su base clinica, quando presente anemia emolitica microangiopatica e piastrinopenia, ma viene poi <span className="text-red-600 font-semibold">confermata attraverso il dosaggio dell'attività dell'ADAMTS13</span> che deve essere &lt;10% e <span className="text-red-600 font-semibold">la ricerca degli autoanticorpi</span>.
              </p>
              <p>
                La terapia cardine della PTT autoimmune è la plasma-exchenge (PEX) che ha lo scopo di rimuovere gli anticorpi circolanti e rifornire di ADAMTS13 attraverso lo scambio con plasma fresco congelato, la terapia steroidea come immunosoppressore e il Caplacizumab nano anticorpo che ha la capacità di impedire l'aggregazione piastrinica al fattore di von Willebrand ed impedisce le ischemie tissutali dovute alla formazione dei trombi nella microcircolazione, riducendo così la mortalità. Mentre per la forma congenita la terapia cardine è l'infusione di plasma fresco congelato, a breve sarà disponibile in commercio l'ADAMTS13 ricombinante come terapia sostitutiva.
              </p>
              <p className="font-semibold">
                Il <span className="text-red-600">trattamento tempestivo</span> sia della forma acquisita che di quella congenita riduce drasticamente la mortalità e morbidità della malattia.
              </p>
            </div>
          </section>

          <section className="bg-green-50 p-6 rounded-lg">
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                E' pertanto fondamentale avere a disposizione <span className="text-red-600 font-semibold">il dosaggio dell'attività</span> dell'ADAMTS13 per confermare o meno la diagnosi e per ridurre i costi nel caso di una diagnosi alternativa. Dopo la risposta al trattamento è importante il monitoraggio dell'attività dell'ADAMTS13 come da indicazione delle recenti linee guida, soprattutto nella forma acquisita autoimmune.
              </p>
              <p>
                Infatti, una riduzione dell'attività &lt;10% dell'enzima espone il paziente ad un elevato rischio di ricaduta della malattia. In questi casi è importante fare una terapia immunosoppressiva per prevenire la recidiva.
              </p>
            </div>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-red-600 mb-4">Conosci il progetto</h3>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                La Ematologia, centro di riferimento regionale per questa patologia, <span className="text-red-600 font-semibold">non è possibile eseguire il test per l'attività dell'ADAMTS13</span> e la ricerca di autoanticorpi negli 81 pazienti seguiti, pur avendo a disposizione la strumentazione e l'expertise tecnica, <span className="text-red-600 font-semibold">per la mancanza di reagenti</span>. Questo è dovuto al fatto che tali test, pur essendo previsti dalle guida per la gestione della malattia, non sono stati ancora inseriti nei LEA e quindi non sono attualmente rimborsabili, ma si possono eseguire solo con fondi privati, con l'impossibilità di avere i risultati in tempo reale.
              </p>
              <p>
                Nel laboratorio di coagulazione dell'Ematologia è già presente uno strumento con il quale, utilizzando reagenti specifici, è possibile eseguire il test dell'attività dell'ADAMTS13 e la ricerca degli anticorpi.
              </p>
              <p>
                Avendo pertanto in laboratorio già presente l'apparecchiatura e l'expertise tecnica per eseguire le analisi e per la refertazione dei risultati, l'Associazione Robin Hood Roma ODV si è impegnata per l'acquisto dei reagenti specifici per eseguire attività e ricerca anticorpi anti ADAMTS13.
              </p>
            </div>
          </section>

          <section className="bg-red-50 p-6 rounded-lg">
            <h4 className="text-xl font-bold text-primary mb-4">Impegno economico annuo</h4>
            <p className="text-gray-700 mb-4">Di seguito si presenta una stima dell'impegno economico annuo dell'associazione, basata sull'attuale numero di 81 pazienti:</p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Per il dosaggio dell'enzima, sono necessari <strong>10 kits all'anno</strong> (ogni kit da 25 test costa 5.000 euro = <strong className="text-red-600">50.000 euro</strong>)</li>
              <li>Per il dosaggio degli anticorpi, servono <strong>2 kits all'anno</strong> (ogni kit da 96 test costa 835 Euro = <strong className="text-red-600">1.670 Euro</strong>).</li>
            </ul>
          </section>

          <section className="bg-green-50 p-6 rounded-lg border-l-4 border-primary">
            <p className="text-gray-700 text-lg font-semibold">
              Nonostante l'impegno economico significativo (<strong className="text-red-600">oltre 50.000 euro annui</strong>), l'Associazione Robin Hood Roma ODV ritiene il progetto di estrema importanza, perché permette un'adeguata e tempestiva assistenza a tutti i bambini e agli adulti affetti da questa rara malattia.
            </p>
          </section>

          <div className="text-center pt-6">
            <Link
              to="/sostienici"
              onClick={() => setIsModalOpen(false)}
              className="inline-block px-8 py-4 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Sostieni il Progetto
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Evento18Ottobre;
